@if (savedCart$ | async; as cart) {
  <div class="cx-saved-cart-restore-btns row">
    @if (!isRestricted) {
      <div class="col-xs-12 col-md-5 col-lg-4">
        <button class="btn btn-secondary btn-block" (click)="openDialog(cart, SavedCartFormType.DELETE)">
          {{ 'customSavedCartDetails.deleteSavedCart' | cxTranslate }}
        </button>
      </div>
    }
    @if (!disableActivateButton && !isRestricted) {
      <div class="col-xs-12 col-md-5 col-lg-4">
        <button
          class="btn btn-secondary btn-block"
          (click)="restoreSavedCart(cart?.code)"
          >
          {{ 'customSavedCartList.makeCartActive' | cxTranslate }}
        </button>
      </div>
    }
  </div>
}
